<ion-button
  class="button"
  [type]="type"
  [expand]="expand"
  [fill]="fill"
  [color]="color"
  [size]="size"
  [shape]="shape"
  [strong]="strong"
  [disabled]="disabled"
  [routerLink]="routerLink"
  [routerDirection]="routerDirection"
  [href]="href"
  [target]="target"
  [download]="download"
  [rel]="rel"
>
  <ng-content></ng-content>
</ion-button>
